import { useState } from 'react';
import { CALCOM_EMBED_LINK } from '../config';

/* The live site books demos through Cal.com, not through a form — real
   availability, timezone handling, calendar invites, reschedule and cancel
   links. Both /book-demo and /resource-optimizer/book embed the same link, so
   the new pages embed it too rather than posting to /api/v1/contact.

   Same env var the host reads, same default link. */

export const CALCOM_BOOKING_URL = `https://cal.com/${CALCOM_EMBED_LINK}`;

export default function CalEmbed({ title = 'Book a demo with TeamGrid', height = 660, inline = false }) {
  const [loaded, setLoaded] = useState(false);
  const src = inline ? `${CALCOM_BOOKING_URL}?embed=true&embedType=inline` : CALCOM_BOOKING_URL;

  return (
    <div className="cal-embed" style={{ position: 'relative', minHeight: `${height}px` }}>
      {!loaded && (
        <div
          aria-hidden="true"
          style={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '14px',
            background: '#fff',
            border: '1px solid var(--line)',
            borderRadius: '16px',
          }}
        >
          <img src="/assets/mark-teamgrid.svg" alt="" style={{ width: '34px', opacity: 0.7 }} />
          <span
            style={{
              width: '22px',
              height: '22px',
              border: '2px solid var(--line)',
              borderTopColor: 'var(--teal-deep)',
              borderRadius: '50%',
              animation: 'cal-spin .8s linear infinite',
            }}
          />
          <style>{'@keyframes cal-spin{to{transform:rotate(360deg)}}'}</style>
        </div>
      )}
      <iframe
        title={title}
        src={src}
        onLoad={() => setLoaded(true)}
        style={{
          width: '100%',
          height: `${height}px`,
          border: '1px solid var(--line)',
          borderRadius: '16px',
          background: '#fff',
          opacity: loaded ? 1 : 0,
          transition: 'opacity .25s ease',
        }}
      />
    </div>
  );
}
